import React from 'react';
import { FolderPlus, Settings, Archive } from 'lucide-react';
import { useAuth } from '../contexts/AuthContext';
import { useLanguage } from '../contexts/LanguageContext'; // Updated import path

interface NavigationProps {
  onNavigateToProjects: () => void;
  onNavigateToAdmin: () => void;
  onViewArchived: () => void;
}

const Navigation: React.FC<NavigationProps> = ({ onNavigateToProjects, onNavigateToAdmin, onViewArchived }) => {
  const { currentUser } = useAuth();
  const { t } = useLanguage();

  return (
    <nav className="app-navigation">
      <div className="max-w-7xl mx-auto">
        <div className="flex items-center space-x-6">
          <button onClick={onNavigateToProjects} className="nav-button flex items-center">
            <FolderPlus className="w-5 h-5 mr-2" />{t('general.projects')}
          </button>
          <button onClick={onViewArchived} className="nav-button flex items-center">
            <Archive className="w-5 h-5 mr-2" /> {t('project.archived', { defaultValue: 'Archived' })}
          </button>
          {currentUser?.role === 'admin' && (
            <button onClick={onNavigateToAdmin} className="nav-button flex items-center">
              <Settings className="w-5 h-5 mr-2" />{t('admin.panel')}
            </button>
          )}
        </div>
      </div>
    </nav>
  );
};

export default Navigation;
